@if (spec(); as chartSpec) {
  <div class="chart-card" [class.chart-card--expanded]="isExpanded">
    @if (chartSpec.title) {
      <div class="chart-card__caption">{{ chartSpec.title }}</div>
    }

    <div class="chart-card__canvas">
      <canvas #chartCanvas role="img" [attr.aria-label]="ariaLabel()"></canvas>
    </div>

    @if (!isExpanded) {
      <button
        type="button"
        class="chart-card__expand"
        [attr.aria-label]="'GNR_ALLO_CHART_EXPAND' | translate"
        (click)="openExpanded()">
        <mat-icon class="chart-card__expand-icon">open_in_full</mat-icon>
      </button>
    } @else {
      <button
        type="button"
        class="chart-card__close"
        [attr.aria-label]="'CMD_CLOSE' | translate"
        (click)="closeExpanded()">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    }
  </div>
} @else {
  <p class="chart-card__failed">{{ 'GNR_ALLO_CHART_FAILED' | translate }}</p>
}
